import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { UnitActivity } from '@models/imported/SagaSchema/UnitActivity';
import { Subscription } from 'rxjs';
import { EngagedUnitsService } from '../../services/engaged-units/engaged-units.service';

@Component({
  selector: 'app-callcard-list-engaged-vehicles',
  templateUrl: './callcard-list-engaged-vehicles.component.html',
  styleUrls: ['./callcard-list-engaged-vehicles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CallcardListEngagedVehiclesComponent implements OnInit, OnDestroy {
  @Input()
  callcard: CallCard;
  @Input()
  isMyCallcard: boolean;

  units: UnitActivity[];

  private engagedUnitsChangeSub: Subscription;

  constructor(private engagedUnits: EngagedUnitsService, private changeDetector: ChangeDetectorRef) {}

  ngOnInit() {
    this.units = this.engagedUnits.getEngagedUnits(this.callcard.ObjGuid);
    this.engagedUnitsChangeSub = this.engagedUnits.$onChange.subscribe(() => this.changeDetector.markForCheck());
  }

  ngOnDestroy() {
    this.engagedUnitsChangeSub?.unsubscribe();
  }
}
